import { useEffect, FunctionComponent } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/pc/');

const I: FunctionComponent = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('landingPage');

    let ScrollMagic: any;
    let controller: any;
    useEffect(() => {
        ScrollMagic = (window as any).ScrollMagic;
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);

    useEffect(() => {
        const root = '.scroll-trigger-origin-I';
        const origin = `${root} .sticky-box .first-screen .content`;
        const duration = window.innerHeight / 2;
        // 时间轴动画
        const TL = new TimelineMax();
        const content = TweenMax.to(origin, 0.5, { opacity: 1, ease: undefined });
        const firstScreen = TweenMax.to(`${root} .first-screen`, 1, { 'background-color': 'rgba(0, 0, 0, 0.6)', ease: undefined });
        TL.add(content, 0).add(firstScreen, 0.5);
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onEnter', offset: 0, duration });
        scene.setTween(TL);
        controller.addScene(scene);
    }, []);

    return (
        <section className={`I ${css.I} scroll-trigger-origin-I`}>
            <div className="sticky-box">
                {/* 首屏 */}
                <article className="first-screen from">
                    <div className="content from">
                        <p className="secH_title">{t('secI_title')}</p>
                        <p className="secH_desc">{t('secI_desc')}</p>
                    </div>
                </article>

                <article className="bg-screen">
                    <EFPic name={['generator.webp', 'generator.jpg']} alt={t('secI_title')} />
                </article>
            </div>
        </section>
    );
};

export default I;
